import React from 'react';
import { motion } from 'framer-motion';
import { Github, ExternalLink } from 'lucide-react';

const ProjectCard = ({ project, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="bg-white dark:bg-neutral-900 rounded-2xl border border-neutral-200 dark:border-neutral-800 overflow-hidden hover:shadow-xl hover:shadow-primary-500/20 dark:hover:shadow-primary-500/10 hover:border-primary-300 dark:hover:border-primary-600 transition-all group"
    >
      <div className="p-6 md:p-8">
        <div className="flex items-start justify-between mb-4">
          <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-primary-600 dark:from-primary-400 dark:to-primary-500 rounded-lg flex items-center justify-center shadow-lg">
            <span className="text-white font-bold text-xl">{project.title.charAt(0)}</span>
          </div>
          {project.github && (
            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors"
              aria-label="View on GitHub"
            >
              <Github className="w-5 h-5 text-neutral-600 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors" />
            </a>
          )}
        </div>

        <h3 className="text-xl md:text-2xl font-bold text-neutral-900 dark:text-neutral-50 mb-3 group-hover:text-primary-600 dark:group-hover:text-primary-300 transition-colors">
          {project.title}
        </h3>

        <p className="text-neutral-600 dark:text-neutral-400 leading-relaxed mb-6">
          {project.description}
        </p>

        <div className="flex flex-wrap gap-2">
          {project.techStack.map((tech, techIndex) => (
            <span
              key={techIndex}
              className="px-3 py-1 bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300 rounded-full text-sm font-medium border border-primary-200 dark:border-primary-700"
            >
              {tech}
            </span>
          ))}
        </div>

        {project.github && (
          <div className="mt-6 pt-6 border-t border-neutral-200 dark:border-neutral-800">
            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-primary-600 dark:text-primary-400 font-medium hover:text-primary-700 dark:hover:text-primary-200 transition-colors"
            >
              View Project
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default ProjectCard;
